import axios from 'axios'
import { baseUrl } from '../assets/Animations'
import { getRequestHeaders } from '../api'
export const getOnboardingCards = (setOnboardingCards) => {
    return axios.get(`${baseUrl}/student-onboarding`, getRequestHeaders())
    .then(response => {
      let tally = 0;
  
      // Loop through each onboarding card
      response.data.forEach(card => {
        if (card.whichList === 'scheduling') {
          // Check if all subtasks are incomplete (subtaskCompleted is false)
          const allIncomplete = card.todoSubtasks.every(subtask => !subtask.subtaskCompleted);
  
          // If all subtasks are incomplete, the card is considered "untouched"
          if (allIncomplete) {
            tally += 1;
          }
        }
      });
  
      setOnboardingCards(tally);  // Update the state with the tally
      console.log(response.data);
    })
    .catch(error => {
      console.error("Error fetching onboarding cards:", error);
    });
}
export const getCancellations = (setCancellations) => {
    return axios.get(`${baseUrl}/cancellation`)
    .then((response) => {
        let untouched = response.data.filter(cancellation => {
            return cancellation.untouchedByAdmin && cancellation.teacherCancelled && !cancellation.hiddenByAdmin;
        })
        console.log(untouched);
        setCancellations(untouched.length);
    })
    .catch((error) => {
        console.error("Error fetching cancellations:", error);
    });
}
export const getApplications = (setApplications) => {
    return axios.get(`${baseUrl}/applications`, getRequestHeaders())
    .then(response => {
        let tally = 0
        for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].archived === false) {
                tally += 1
            }
        }
        setApplications(tally)
    })
    .catch(error => {
        console.log(error)
    })
}
export const getTimesheets = (month, year, setTimesheets) => {
    return axios.get(`${baseUrl}/teachertimesheet/${month}/${year}`, getRequestHeaders())
    .then(response => {
        let timesheets = 0
        for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].status !== 'Approved') {
                timesheets += 1
            }
        }
        setTimesheets(timesheets)
    })
    .catch(error => {
        console.log(error)
    })
}
export const getInvoices = (month, year, setInvoices) => {
    return axios.get(`${baseUrl}/invoices/${month}/${year}`, getRequestHeaders())
    .then(response => {
        //tally invoices with status !== 'In Wave'
        let invoices = 0
        for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].status !== 'In Wave') {
                invoices += 1
            }
        }
        setInvoices(invoices)
    })
    .catch(error => {
        console.log(error)
    })
}
export const getTasks = (setTasks) => {
    return axios.get(`${baseUrl}/tasks`, getRequestHeaders())
    .then(response => {
        let tally = 0
        for(let i = 0; i < response.data.length; i++) {
            if( new Date(response.data[i].todoDueDate) < new Date(new Date().setDate(new Date().getDate() + 1)).setHours(1, 0, 0, 0)){
                tally += 1
            }
        }
        setTasks(tally)
    })
    .catch(error => {
        console.log(error)
    })
}